/* global THREE */
import aframe from "aframe";
// import { eventBinder, bindEvent } from "aframe-event-decorators";
import { bindEvent } from "aframe-event-decorators";

aframe.registerComponent("omega-turret-tracking", {
  schema: {
    baseAxis: { default: false },
    turretAxis: { default: false }
  },
  update(oldData) {
    if (this.baseAxis) {
      this.baseAxis.visible = !!this.data.baseAxis;
      this.turretAxis.visible = !!this.data.turretAxis;
    }
  },
  trackWorldLocation: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();
    const v3 = new THREE.Vector3();
    const v4 = new THREE.Vector3();

    const q1 = new THREE.Quaternion();
    const q2 = new THREE.Quaternion();

    return function (worldPos) {
      if (!this.baseBone || !this.turretBone) {
        throw new Error("Bones weren't found");
      }

      const base = this.baseBone;
      const turret = this.turretBone;

      const baseLocalDir = base.parent
        .worldToLocal(v1.copy(worldPos))
        .setY(0)
        .normalize();
      const baseForwards = v2.set(-1, 0, 0).applyQuaternion(base.quaternion);
      base.setRotationFromQuaternion(
        q1
          .setFromUnitVectors(baseForwards, baseLocalDir)
          .premultiply(base.quaternion)
      );
      base.updateMatrixWorld();

      const turretLocalDir = base
        .worldToLocal(v3.copy(worldPos))
        .setZ(0)
        .normalize();
      const turretForwards = v4.set(0, 1, 0).applyQuaternion(turret.quaternion);
      turret.setRotationFromQuaternion(
        q2
          .setFromUnitVectors(turretForwards, turretLocalDir)
          .premultiply(turret.quaternion)
      );
    };
  })(),
  object3dset: bindEvent(function (evt) {
    if (evt.detail && evt.detail.type === "mesh") {
      const o = evt.detail.object;
      if (o.name === "omega-missile-silo") {
        this.baseBone = o.getObjectByName("turret-base");
        this.turretBone = o.getObjectByName("turret");

        this.baseAxis = new THREE.AxesHelper(0.1);
        this.baseBone.add(this.baseAxis);
        this.baseAxis.visible = !!this.data.baseAxis;

        this.turretAxis = new THREE.AxesHelper(0.1);
        this.turretBone.add(this.turretAxis);
        this.turretAxis.visible = !!this.data.turretAxis;
      }
    }
  })
});
